import { useState, useEffect } from 'react'
import { supabaseGetter } from '~/api/supabase-getter'

export const useCropFamilyTypes = () => {
  const [cropFamilyTypes, setCropFamilyTypes] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    async function fetchData() {
      setLoading(true)
      setError(null)
      try {
        const { data, error: fetchError } = await supabaseGetter.cropFamilyTypes.getAll()
        if (fetchError) throw fetchError
        setCropFamilyTypes(data || [])
      } catch (err) {
        console.error('Error fetching crop family types:', err)
        setError(err.message)
        setCropFamilyTypes([])
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [])

  return { cropFamilyTypes, loading, error }
}
